<template>
  <span>{{minuteString+'分'+secondString+'秒'}}</span>
</template>

<script>
import { Toast } from 'mint-ui'

export default {
  data () {
    return {
      hour: '',
      minute: '',
      second: '',
      timer: ''
    }
  },
  props: ['remainTime', 'id'],
  mounted () {
    if (this.remainTime > 0) {
      this.hour = Math.floor((this.remainTime / 3600) % 24)
      this.minute = Math.floor((this.remainTime / 60) % 60)
      this.second = Math.floor(this.remainTime % 60)
      this.countDowm(this.id)
    }
  },
  methods: {
    countDowm (id) {
      var self = this
      clearInterval(this.timer)
      this.timer = setInterval(function () {
        if (self.hour === 0) {
          if (self.minute !== 0 && self.second === 0) {
            self.second = 59
            self.minute -= 1
          } else if (self.minute === 0 && self.second === 0) {
            self.second = 0
            self.$emit('countDowmEnd', true)
            clearInterval(self.timer)
            self.checkstatus(id)
          } else {
            self.second -= 1
          }
        } else {
          if (self.minute !== 0 && self.second === 0) {
            self.second = 59
            self.minute -= 1
          } else if (self.minute === 0 && self.second === 0) {
            self.hour -= 1
            self.minute = 59
            self.second = 59
          } else {
            self.second -= 1
          }
        }
      }, 1000)
    },
    checkstatus: function (id) {
      var self = this
      self.$api.DRAWDETAIL({
        id: id
      }).then(res => {
        if (res.code === 0) {
          if (res.data.draw.drawStatus === 100) {
            Toast({
              message: '开奖成功',
              className: 'offcn-toast'
            })
            setTimeout(function () {
              self.$router.push({path: 'winlist', query: {id: id}})
            }, 1000)
             if (!webAccessor) return // eslint-disable-line
             webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
              path: 'run_lottery',
              data: {
                dataInfo: {id: id},
                roomId: this.roomId
              }
            }))
          } else if (res.data.draw.drawStatus === 200) {
            Toast({
              message: '开奖失败',
              className: 'offcn-toast'
            })
            setTimeout(function () {
              window.location.reload()
            }, 1000)
             if (!webAccessor) return // eslint-disable-line
             webAccessor.boardcast(JSON.stringify({ // eslint-disable-line
              path: 'end_lottery',
              data: {
                dataInfo: {id: id},
                roomId: this.roomId
              }
            }))
          } else if (res.data.draw.drawStatus === 300) {
            setTimeout(function () {
              self.checkstatus(id)
            }, 1000)
          }
        }
      }, err => {
        console.log(err)
      })
    },
    formatNum (num) {
      return num < 10 ? '0' + num : '' + num
    }
  },
  computed: {
    minuteString () {
      return this.minute
    },
    secondString () {
      return this.formatNum(this.second)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/offcn-teacher-lottery/countdown.vue